import styled from 'styled-components'
import LogoImage from '../assets/images/energy-level-tracker/logo.svg'

export const Logo = styled(LogoImage)`
  width: 100%;
  height: auto;
`
